import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox3} from '../components';

class Dashboard3 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox3/>
			</Fragment>
		);
	}
}

Dashboard3.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard3.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard3;